import { Injectable } from '@angular/core';
import {BaseDatabaseService} from '../BaseDatabaseService';

@Injectable({
  providedIn: 'root'
})
export class FormItemsService extends BaseDatabaseService{

  private collectionName = 'formItems';

  constructor() {
    super();
  }

  getFormItems() {
    return this.db.collection(this.collectionName).get();
  }

  getOneFormItem(id){
    return this.db.collection(this.collectionName).doc(id).get();
  }

  create(key, form) {
    const obj = {
      required: form.requiredDefault,
      requiredDefault: form.requiredDefault,
      type: this.db.collection('formItemDateType').doc(form.type),
      visible: form.visibleDefault,
      visibleDefault: form.visibleDefault,
      visibleText: form.visibleText
    };

    return this.db.collection(this.collectionName).doc(key).set(obj);
  }

  deleteFormItems(key){
    return this.db.collection(this.collectionName).doc(key).delete();
  }

  saveCollection(id, collection) {
    return this.db.collection(this.collectionName).doc(id).collection('enum').doc('tshirtSize').set(collection);
  }

  getCollection(id){
    return this.db.collection(this.collectionName).doc(id).collection('enum');
  }

  getEnum(id){
    return this.db.collection(this.collectionName).doc(id).collection('enum').doc(id).get();
  }
}
